import { render, staticRenderFns } from "./ProducerCard.vue?vue&type=template&id=9bbd8d86&scoped=true&"
import script from "./ProducerCard.vue?vue&type=script&lang=js&"
export * from "./ProducerCard.vue?vue&type=script&lang=js&"
import style0 from "./ProducerCard.vue?vue&type=style&index=0&id=9bbd8d86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bbd8d86",
  null
  
)

export default component.exports